import { useRef, useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";

import { imgLogoEst, imgLogoPrs } from "../../assets/img"
import { useSelector } from "react-redux";

const Navbar = () => {
  const navbarRef = useRef(null);
  const auth = useSelector((state) => state.auth);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const menuItems = [
    { label: "Beranda", path: "/" },
    { label: "Karir", path: "/career" },
    { label: "Tentang Kami", path: "/about" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      ref={navbarRef}
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled || isMenuOpen ? "bg-white shadow" : "bg-transparent"}`}
    >
      <div className="w-full mx-auto px-6 lg:px-14 xl:px-24 2xl:px-32 h-20 flex items-center justify-between">
        <Link to="/" className="w-48 flex items-end gap-1">
          <div className="w-12">
            <img
              src={imgLogoEst}
              alt="Logo EST"
              className="w-full object-contain"
            />
          </div>
          <div className="w-12">
            <img
              src={imgLogoPrs}
              alt="Logo PRS"
              className="w-full object-contain"
            />
          </div>
        </Link>

        <ul className="hidden lg:flex space-x-8">
          {menuItems.map((item) => (
            <li key={item.label}>
              <NavLink
                to={item.path}
                end={item.path === "/"}
                className={({
                  isActive,
                }) => `relative font-semibold inline-block py-2 transition-colors ${
                  scrolled
                    ? isActive
                      ? "text-blue-600"
                      : "text-gray-600 hover:text-blue-600"
                    : "text-white hover:text-white"
                }
                `}
              >
                {({ isActive }) => (
                  <>
                    {item.label}
                    {isActive && (
                      <span
                        className={`absolute left-0 top-7 w-full h-[2px] hover:bg-blue-600 ${scrolled ? "bg-blue-600" : "bg-white"}`}
                      />
                    )}
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="hidden lg:flex items-center gap-4">
          {auth?.isAuthenticated ? (
            <Link
              to="/app/dashboard"
              className={`px-4 py-2 ml-12 rounded-lg transition
              ${
                scrolled
                  ? "bg-blue-600 text-white hover:bg-blue-800"
                  : "bg-white text-black hover:bg-gray-200"
              }
            `}
              onClick={() => setIsMenuOpen(false)}
            >
              Dashboard
            </Link>
          ) : (
            <>
              <Link
                to="/register"
                className={`px-4 py-2 rounded-lg border transition
              ${
                scrolled
                  ? "border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white"
                  : "border-white text-white hover:bg-white hover:text-black"
              }
            `}
              >
                Daftar
              </Link>
              <Link
                to="/login"
                className={`px-4 py-2 rounded-lg transition
              ${
                scrolled
                  ? "bg-blue-600 text-white hover:bg-blue-800"
                  : "bg-white text-black hover:bg-gray-200"
              }
            `}
              >
                Masuk
              </Link>
            </>
          )}
        </div>

        <button
          className={`lg:hidden text-3xl ${
            scrolled || isMenuOpen ? "text-black" : "text-white"
          }`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <HiX /> : <HiMenu />}
        </button>
      </div>

      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 bg-white
          ${isMenuOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"}
        `}
      >
        <ul className="flex flex-col">
          {menuItems.map((item, i) => (
            <li key={i} className="border-b border-gray-200">
              <Link
                to={item.path}
                className="block px-6 py-4 font-semibold"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </Link>
            </li>
          ))}

          <li className="p-6 flex gap-4">
            {auth?.isAuthenticated ? (
              <Link
                to="/app/dashboard"
                className={`px-4 py-2 rounded-lg transition w-full text-center bg-blue-600 text-white hover:bg-blue-800`}
                onClick={() => setIsMenuOpen(false)}
              >
                Dashboard
              </Link>
            ) : (
              <>
                <Link
                  to="/register"
                  className="flex-1 text-center py-2 border rounded-lg"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Daftar
                </Link>
                <Link
                  to="/login"
                  className="flex-1 text-center py-2 bg-blue-600 text-white rounded-lg"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Masuk
                </Link>
              </>
            )}
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
